export default {
	namespaced: true,
	state: {
        obj: {
            dataSetId: '',
            dataSetName: '',
            SystemDiagnosName: '',
            SystemDiagnosId: '',
            ageValue: '',
            ageValueMeasurementId: '',
            patientId: '',
            generalParameters:[],
            vitalParameters: [],
            vaccinations: [],
            pastDiseases: [],
            instrumentalResearchParameters: [],
            labResearchParameters: [],
            familyHistory: [],
            jointConditions: [],
            anthropometricParameters: [],
            psychicalParameters: [],
            diagnosis: [],
            anamnesis: []
        },
        vitalObj: {
            dialogVital: false,
            headersVital: [
                { text: 'Дата', value: 'eventDate'},
                { text: 'Наименование', value: 'nameId'},
                { text: 'Значение', value: 'valueId'},
                { text: 'ЕИ', value: 'measurementId'},
                { text: 'Действие', value: 'actions', sortable: false }
            ]
        },
        antropometricObj: {
            dialogAntropometric: false,
            headersAntropometric: [
                { text: 'Дата', value: 'eventDate'},
                { text: 'Наименование', value: 'nameId'},
                { text: 'Значение', value: 'valueId'},
                { text: 'ЕИ', value: 'measurementId'},
                { text: 'Действие', value: 'actions', sortable: false }
            ]
        },
        psyhicObj: {
            dialogPsyhic: false,
            headersPsyhic: [
                { text: 'Группа', value: 'groupId' },
                { text: 'Наименование', value: 'nameId'},
                { text: 'Значение', value: 'valueId'},
                { text: 'ЕИ', value: 'measurementId'},
                { text: 'Действие', value: 'actions', sortable: false }
            ]
        },
        vacObj: {
            dialogVac: false,
            headersVac: [
                { text: 'Возраст', value: 'ageValue'},
                { text: 'Возраст(Ед. изм.)', value: 'ageMeasurementId'},
                { text: 'Вакцинация/ревакцинация', value: 'vaccination'},
                { text: 'Действие', value: 'actions', sortable: false}
            ],
        },
        famObj: {
            dialogFam: false,
            headersFamilyAnamnez: [
                { text: 'Степень родства', value: 'relationDegrees'},
                { text: 'Заболевание', value: 'mkb10DiseaseId', view: false  },
                { text: 'Действие', value: 'actions', sortable: false}
            ]
        },
        diseaseObj: {
            dialogDisease: false,
            headersTransferredDiseases: [
                { text: 'Возраст', value: 'ageValue'},
                { text: 'Возраст(Ед. изм.)', value: 'ageMeasurementId'},
                { text: 'Заболевание', value: 'mkb10DiseaseId'},
                { text: 'Действие', value: 'actions', sortable: false}
            ]
        },
        genConObj:{
            dialogGenCon: false,
            headersGeneralCondition: [
                { text: 'Система организма', value: 'bodySystemId'},
                { text: 'Группа', value: 'groupId' },
                { text: 'Наименование', value: 'nameId' },
                { text: 'Значение', value: 'valueId' },
                { text: 'ЕИ', value: 'measurementId' },
                { text: 'Действие', value: 'actions', sortable: false}
            ],
        },
        conJointsObj: {
            dialogconJoint: false,
            headersConditionJoints: [
                { text: 'Дата', value: 'eventDate'},
                { text: 'Суставы с болью', value: 'jointPains'},
                { text: 'Суставы с отеком', value: 'jointSwellings'},
                { text: 'Суставы с ограниченным движением', value: 'jointLimiteds'},
                { text: 'Количество суставов с активным артритом', value: 'jointActiveArtritCount'},
                { text: 'Количество суставов с нарушением функции', value: 'jointImpairedCount'},
                { text: 'Действие', value: 'actions', sortable: false, view: true }
            ],
        },
        instrumentalObj:{
            dialogInstrumental: false,
            headersInstrumental: [
                { text: 'Группа', value: 'groupId'},
                { text: 'Наименование', value: 'nameId'},
                { text: 'Заключение', value: 'valueId'},
                { text: 'ЕИ', value: 'measurementId' },
                { text: 'Действие', value: 'actions', sortable: false}
            ],
        },
        labObj:{
            dialogLaboratory: false,
            headersLaboratory: [
                { text: 'Группа', value: 'groupId'},
                { text: 'Наименование', value: 'nameId'},
                { text: 'Значение', value: 'valueId'},
                { text: 'ЕИ', value: 'measurementId'},
                { text: 'Действие', value: 'actions', sortable: false}
            ],
        },
        anamnezObj:{
            dialogAnamnez: false,
            headersAnamnez: [
                { text: 'Группа', value: 'groupId'},
                { text: 'Наименование', value: 'nameId'},
                { text: 'Значение', value: 'valueId'},
                { text: 'ЕИ', value: 'measurementId'},
                { text: 'Действие', value: 'actions', sortable: false}
            ],
        },
	},
	getters: {
		obj: state => state.obj,
        getDataSetId: state => state.obj.dataSetId,

        // витальные параметры
		headersVital: state => state.vitalObj.headersVital,
		dialogVital: state => state.vitalObj.dialogVital,
		listVital: state => state.obj.vitalParameters,

        // антропометрические показатели
        headersAntropometric: state => state.antropometricObj.headersAntropometric,
		dialogAntropometric: state => state.antropometricObj.dialogAntropometric,
		listAntropometric: state => state.obj.anthropometricParameters,

        // психические показатели
        headersPsyhic: state => state.psyhicObj.headersPsyhic,
		dialogPsyhic: state => state.psyhicObj.dialogPsyhic,
		listPsyhic: state => state.obj.psychicalParameters,

        // вакцинация
        headersVac: state=> state.vacObj.headersVac,
        dialogVac: state => state.vacObj.dialogVac,
        listVac: state => state.obj.vaccinations,

        // семейный анамнез
        headersFam: state=> state.famObj.headersFamilyAnamnez,
        dialogFam: state => state.famObj.dialogFam,
        listFam: state => state.obj.familyHistory,

        //перенесенные заболевания
        headersDisease: state=> state.diseaseObj.headersTransferredDiseases,
        dialogDisease: state => state.diseaseObj.dialogDisease,
        listDisease: state => state.obj.pastDiseases,

        //общее состояние
        headersGenCon: state=> state.genConObj.headersGeneralCondition,
        dialogGenCon: state => state.genConObj.dialogGenCon,
        listGenCon: state => state.obj.generalParameters,

        //Состояние суставов
        headersConJoints: state=> state.conJointsObj.headersConditionJoints,
        dialogConJoints: state => state.conJointsObj.dialogconJoint,
        listConJoints: state => state.obj.jointConditions,

        //Инструментальные исследования
        headersInstrumental: state=> state.instrumentalObj.headersInstrumental,
        dialogInstrumental: state => state.instrumentalObj.dialogInstrumental,
        listInstrumental: state => state.obj.instrumentalResearchParameters,

        //Лабораторные исследования
        headersLab: state=> state.labObj.headersLaboratory,
        dialogLab: state => state.labObj.dialogLaboratory,
        listLab: state => state.obj.labResearchParameters,

        //диагнозы
        listDiagnosis: state => state.obj.diagnosis[0],

        //Анамнез
        headersAnamnez: state=> state.anamnezObj.headersAnamnez,
        dialogAnamnez: state => state.anamnezObj.dialogAnamnez,
        listAnamnez: state => state.obj.anamnesis,
	},
	mutations: {
        change(state, obj) {
            state[obj.nameGroup][obj.nameProps] = obj.value
        },
        cleanArray(state){
            state.obj =  {
                dataSetId: '',
                dataSetName: '',
                systemDiagnosName: '',
                systemDiagnosId: '',
                patientId: null,
                generalParameters:[],
                vitalParameters: [],
                vaccinations: [],
                pastDiseases: [],
                instrumentalResearchParameters: [],
                labResearchParameters: [],
                familyHistory: [],
                jointConditions: [],
                anthropometricParameters: [],
                psychicalParameters: [],
                diagnosis: [],
                anamnesis: []
            }
        },
        updateData(state, obj) {
            console.log(obj);
            if(obj.name === 'diagnosis') state.obj.diagnosis = []
            if(obj.edite) {

                Object.assign(state.obj[obj.name][obj.index], obj.value);
            } else {
                // console.log(obj);
                state.obj[obj.name].push(obj.value);
            }
        },
         changeGlobal(state,obj) {

            state.obj = obj
        },
        deleteData(state, obj) {
            state.obj[obj.name].splice(obj.index, 1);
        },

	},
	actions: {
        save({ commit }, obj) {
            console.log(obj);
            return new Promise((res, rej) => {
                try {
                    commit('updateData', obj);
                    res(true);
                } catch (error) {
                    rej(error);
                }
            })
        },
        delete({ commit }, obj) {
            return new Promise((res, rej) => {
                try {
                    commit('deleteData', obj);
                    res(true);
                } catch (error) {
                    rej(error);
                }
            })
        }

    }
};
